import { Component } from '@angular/core';
import { PhcUrl } from '../../../models/interfaces/portfolio-health-check-data';
import { getPHCUrls } from '../../../utils/functions.utils';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics/adobe-analytics.service';

@Component({
  selector: 'PW1-no-goals',
  templateUrl: './no-goals.component.html',
  styleUrls: ['./no-goals.component.scss']
})
export class NoGoalsComponent  {

  urls: PhcUrl = {}

  constructor(private adobeAnalyticsService: AdobeAnalyticsService){
    this.urls = getPHCUrls()
  }

  callToAction() {
    this.adobeAnalyticsService.CreateCTATrigger('no-goals', 'get-started', 'Button');
  }

}
